// UploadMedia.jsx
import React, { useState, useCallback } from "react";
import upload from "../assets/Images/Uploadminimalistic.svg";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LoadingSpinner from "./Loading";

const UploadBusinessMedia = ({
    onfileAdd,       // field name string (ex: "manageridurl")
    urlgenerated,    // callback to parent: (data) => {}
    multiple = false,
    message,
}) => {
    const { t } = useTranslation();
    const [fileError, setFileError] = useState(false);
    const [sizeError, setSizeError] = useState(false);
    const [loading, setLoading] = useState(false);

    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

    // NOTE: this component no longer calls API.
    // It reads files and returns metadata to parent using urlgenerated(data)
    // data shape: { name: onfileAdd, dataUrl: "data:image/..;base64,....", originalName: file.name, size: file.size, type: file.type }

    const onDrop = useCallback(
        (acceptedFiles) => {
            acceptedFiles.forEach((file) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadstart = () => setLoading(true);
                reader.onload = () => {
                    setLoading(false);
                    if (file.size > 5 * 1024 * 1024) {
                        setSizeError(true);
                        return;
                    } else {
                        setSizeError(false);
                    }

                    const base64Full = reader.result; // data:<mime>;base64,xxxx

                    const allowedFileTypes = ["application/pdf", "image/png", "image/jpeg"];
                    if (!allowedFileTypes.includes(file.type)) {
                        setFileError(true);
                        if (message) message(false);
                        return;
                    }
                    setFileError(false);

                    // Return to parent the file metadata (no upload yet)
                    const data = {
                        name: onfileAdd,
                        dataUrl: base64Full,
                        originalName: file.name,
                        size: file.size,
                        type: file.type,
                        user_id,
                    };

                    // Parent will push into its array
                    urlgenerated && urlgenerated(data);
                };

                reader.onerror = (error) => {
                    console.log("Error reading file:", error);
                    setLoading(false);
                };
            });
        },
        [onfileAdd, urlgenerated, message, user_id]
    );

    const { getRootProps, getInputProps } = useDropzone({
        accept: ".pdf, .png, .jpeg, .jpg",
        multiple,
        onDrop,
    });

    return (
        <div className="upload">
            {loading && <LoadingSpinner />}
            <div {...getRootProps()}>
                <input {...getInputProps()} />
                <p className="flex flex-col justify-end text-center text-sm text-body">
                    <span className="flex flex-row justify-center gap-1 items-center font-semibold text-[#1b4597]">
                        <img src={upload} width={18} alt="Upload Icon" />
                        {t("upload file")}
                    </span>
                    <div className="">
                        <span className="text-xs text-body text-[#999999]">
                            {t("Only PDF, PNG, and JPEG files are allowed")}
                        </span>
                        <div className="text-xs text-body text-[#999999]">(max 5mb)</div>
                    </div>
                </p>
            </div>

            {sizeError && <p className="text-red text-xs mt-1">{t("File cannot be more than 5 mb")}</p>}
            {fileError && <p className="text-red text-xs mt-1">{t("Unsupported File Type")}</p>}
        </div>
    );
};

export default UploadBusinessMedia;
